export function useShareUrl(vanityUrl?: string) {
  const url = computed(() => {
    if (import.meta.server) return ''

    if (vanityUrl) {
      return `${window.location.protocol}//${window.location.host}/${vanityUrl}`
    }

    return window.location.href
  })

  return {
    url,
  }
}
